export const LABELS_KEYS = {
  STATUS: 'STATUS',
  DUE_DATE: 'DUE_DATE',
  NUMBER: 'NUMBER',
  VALUE: 'VALUE',
  PAYMENT_DATE: 'PAYMENT_DATE',
}

export const LABELS = {
  [LABELS_KEYS.DUE_DATE]: {
    mobile: 'Venc:',
    desktop: 'Vencimento',
  },
  [LABELS_KEYS.NUMBER]: {
    mobile: 'N.°',
    desktop: 'Fatura N.°',
  },
  [LABELS_KEYS.STATUS]: {
    mobile: '',
    desktop: 'Status',
  },
  [LABELS_KEYS.VALUE]: {
    mobile: 'Valor:',
    desktop: 'Valor',
  },
  [LABELS_KEYS.PAYMENT_DATE]: {
    mobile: 'Pag:',
    desktop: 'Pagamento',
  },
}
